var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#F6F8FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 45C54.6274 45 60 39.6274 60 33C60 26.3726 54.6274 21 48 21C41.3726 21 36 26.3726 36 33C36 39.6274 41.3726 45 48 45Z",
    fill: "#CDD2DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49H46C36.0589 49 28 57.0589 28 67C28 70.3137 30.6863 73 34 73H62C65.3137 73 68 70.3137 68 67C68 57.0589 59.9411 49 50 49Z",
    fill: "#CDD2DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactAvatar);
export default __webpack_public_path__ + "static/media/contactAvatar.e4f6d91cccbc00939469ad1bd97778ee.svg";
export { ForwardRef as ReactComponent };